const RegisterHeader = ({ setAuth, t }) => {
  return (
    <button
      aria-label='Register'
      onClick={() => setAuth('register')}
      className='cursor-pointer text-xs font-semibold uppercase hover:underline'
    >
      {t('Register')}
    </button>
  );
};

export default RegisterHeader;
